<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height pa-0"
        fluid
        :style="`background-image: url('${backgroundImage}'); background-position: center center; background-size: cover;`"
      >
        <v-col offset-sm="1" sm="10">
          <v-row>
            <v-col
              align-lg-self="end"
              cols="12"
              offset-sm="2"
              offset-md="3"
              offset-lg="0"
              sm="8"
              md="6"
              lg="4"
            >
              <v-card fill-height class="elevation-12" :color="color">
                <v-col class="d-flex justify-center">
                  <v-avatar size="200" max-height="100px" tile>
                    <v-img :src="logoImage" height="100%" contain />
                  </v-avatar>
                </v-col>
                <v-card-text>
                  <core-form :submit="login">
                    <v-col>
                      <input-email
                        v-if="loginField === 'email'"
                        label="E-mail"
                        v-model="credentials[loginField]"
                        autofocus
                        placeholder=" "
                      />
                      <input-documento
                        v-if="loginField === 'documento'"
                        label="CPF/CNPJ"
                        v-model="credentials[loginField]"
                        autofocus
                        placeholder=" "
                      />
                      <input-text
                        v-if="loginField === 'username'"
                        label="Usuário"
                        v-model="credentials[loginField]"
                        autofocus
                        placeholder=" "
                      />
                    </v-col>
                    <v-col class="pb-1 pt-2">
                      <input-password
                        label="Senha"
                        v-model="credentials.password"
                      />
                    </v-col>
                    <v-col class="pt-0 pb-10">
                      <router-link
                        to="/lembrar"
                        class="float-right font-weight-medium caption text-decoration-none"
                        >Esqueceu a senha?</router-link
                      >
                      <v-btn
                        type="submit"
                        :disabled="
                          !credentials[loginField] || !credentials.password
                        "
                        color="primary"
                      >
                        Entrar
                      </v-btn>
                      <v-alert
                        v-show="error"
                        type="error"
                        class="mt-3"
                        text
                        icon="error"
                      >
                        {{ error }}
                      </v-alert>
                    </v-col>
                  </core-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
      <core-login-error ref="loginError" @follow="followLogin" />
    </v-main>
  </v-app>
</template>

<script>
export default {
  metaInfo: {
    title: window.env.VUE_APP_NOME + ' - Login',
  },
  data () {
    return {
      credentials: {},
      error: '',
      logoImage: this.$theme.logo || '/assets/imgs/logo.png',
      backgroundImage: this.$theme.background || '/assets/imgs/background.png',
      loginField: 'email',
      showPassword: false,
    };
  },
  methods: {
    login () {
      const th = this;
      th.$api.Autenticacao.Autenticar(th.credentials)
        .then(function (data) {
          if (data.errorCode) {
            th.$refs.loginError.openModal(data);
          } else if (th.$api.UI.PostLoadData(data, true)) {
            th.setUser(data)
          }
        })
        .catch((err) => console.log(err));
    },
    followLogin (data) {
      const th = this;
      th.setUser(data);
    },
    setUser (authResponse) {
      const th = this;
      const user = th.$api.UTIL.Auth.RegisterToken(authResponse);
      if (user) {
        th.$store.dispatch('setUserData', { user }).then(() => {
          th.$router.push({
            path: '/parceiro',
          });
        });
      }
    },
  },
  computed: {
    color: function () {
      return this.$theme.dark ? '#0000007A' : '#FFFFFFCA';
    },
  },
};
</script>
